//
// SortState.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import ClosetObject from "../../../ClosetObject";
import "../../../lib";
import "./DataTreeSortContext";
import "./DimensionalSortContext";
import "./MeasureSortContext";
import "./SortContext";

var SortState = createModule("commons::SortState", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getRelationalSortIndices: [[3]],
        getMeasureSortsForAxis: [[1],4],
        getDimensionalSortForAxis: [1,4],
        hasRelationalSortStatement: [2],
        getRelationalSortsForAxis: [[1],4],
        hasDimensionalSortStatement: [2],
        getDataTreeSortContext: [1],
    },
    {
        _create: [4],
    },
    ,
]);
export default SortState;
